export default "__VITE_ASSET__DozTZmtN__"